import React, { useState, useContext, useEffect, useRef } from 'react'
import TextField from '@material-ui/core/TextField'

import Autocomplete from '@material-ui/lab/Autocomplete'
import CircularProgress from '@material-ui/core/CircularProgress'
import debounce from 'lodash.debounce'

function sleep(delay = 0) {
    return new Promise((resolve) => {
        setTimeout(resolve, delay)
    })
}

const SearchSelectComponent = (props) => {
    const [selectedOption, setSelectedOption] = useState([])
    const [singleOption, setSingleOption] = useState({ show: '', value: '' })
    const [optionData, setOptionData] = useState([])
    const [edit, setEdit] = useState(false)
    const [searchValue, setSearchValue] = useState('')
    const [options, setOptions] = useState([])
    const [showDropdown, setShowDropdown] = useState(false)
    const searchInputRef = useRef(null)
    const [open, setOpen] = useState(false)

    const [loading, setLoading] = useState(false)

    // useEffect(() => {
    //     let active = true

    //     if (!loading) {
    //         return undefined
    //     }

    //     return () => {
    //         active = false
    //     }
    // }, [loading])

    // useEffect(() => {
    //     if (!open) {
    //         setOptions([])
    //     }
    // }, [open])

    function trimVal(data) {
        let value = data
        let arr = value?.split('    ')
        if (arr?.length > 1) {
            value = arr[0].trim() + ' ' + arr[arr.length - 1].trim()
        }
        return value
    }

    useEffect(() => {
        if (props?.options) {
            setOpen(false)
            setOptionData([])
            if (props.options.length) {
                let allData = props.options
                if (props.value && edit) {
                    let singleData = allData.filter((item) => item?.value == props?.value)
                    console.log(allData, 'charity_data==', singleData, 'charity_id', props?.value)
                    setSingleOption({
                        show: trimVal(singleData[0]?.show),
                        value: props.value,
                    })
                    setEdit(false)
                    setLoading(false)
                    setOpen(false)
                } else {
                    setOptionData(allData)
                    setLoading(false)
                    setOpen(true)
                    setShowDropdown(true)
                }
            } else {
                setOptionData([])
                setLoading(false)
                setOpen(false)
                setShowDropdown(false)
            }
        }
    }, [props.options, edit])

    const debounceFunc = debounce((value) => {
        if (searchInputRef.current?.value == value) props.getAllOptions(value)
    }, 1500)

    const handleSearchChange = (value) => {
        setLoading(true)
        setSearchValue(value)
        setSingleOption({ show: value, value: value })
        debounceFunc(value)
    }

    useEffect(() => {
        if (props.value && props.value !== '' && props.options && props.options.length == 0) {
            props.getAllOptions(props.value)
            setEdit(true)
        }
    }, [props.value])

    const getSingleValue = (selectedOption) => {
        selectedOption.show = trimVal(selectedOption.show)

        setSingleOption(selectedOption)
        props.onChange(selectedOption.value)
    }

    useEffect(() => {
        if (props.value == '' && props.onClear) {
            setSingleOption({ show: '', value: '' })
            setOptionData([])
        }
    }, [props.value])

    return (
        // <Autocomplete
        //     id="asynchronous-demo"
        //     style={{ width: 300 }}
        //     open={open}
        //     onOpen={() => {
        //         setOpen(true)
        //     }}
        //     onClose={() => {
        //         setOpen(false)
        //     }}
        //     multiple={false}
        //     value={singleOption}
        //     onChange={(event, value) => {
        //         if (value) {
        //             getSingleValue(value)
        //         } else {
        //             setSingleOption({ show: '', value: '' })
        //             setOptionData([])
        //         }
        //     }}
        //     renderOption={(props, option) => (
        //         <li {...props} key={option.value}>
        //             {' '}
        //             {option.show}{' '}
        //         </li>
        //     )}
        //     getOptionLabel={(option) => option.show}
        //     options={optionData}
        //     loading={loading}
        //     renderInput={(params) => (
        //         <TextField
        //             {...params}
        //             label={props.label}
        //             variant={props.variant ? props.variant : 'outlined'}
        //             error={props.error}
        //             value={props.value}
        //             size={props.size}
        //             name={props.name}
        //             InputProps={{
        //                 ...params.InputProps,
        //                 endAdornment: (
        //                     <React.Fragment>
        //                         {loading ? <CircularProgress color="inherit" size={20} /> : null}
        //                         {params.InputProps.endAdornment}
        //                     </React.Fragment>
        //                 ),
        //             }}
        //             onKeyDown={(e) => {
        //                 if (e.key === 'Enter' && e.target.value) {
        //                     handleSearchChange(e.target.value)
        //                 } else {
        //                     setOptionData([])
        //                     setSingleOption({ show: '', value: '' })
        //                 }
        //             }}
        //             onChange={(e) => {
        //                 if (e.target.value) {
        //                     console.log(e.target.value, 'e.target.value')
        //                     handleSearchChange(e.target.value)
        //                 } else {
        //                     setOptionData([])
        //                     setSingleOption({ show: '', value: '' })
        //                 }
        //             }}
        //             helperText={props.helperText}
        //             autoFocus={props.autoFocus}
        //         />
        //     )}
        // />
        <Autocomplete
            id={props.id}
            options={optionData}
            forcePopupIcon={props.forcePopupIcon}
            onChange={(event, value) => {
                if (value) {
                    getSingleValue(value)
                } else {
                    setSingleOption({ show: '', value: '' })
                    setOptionData([])
                }
            }}
            value={singleOption}
            getOptionLabel={(option) => option.show}
            loading={loading}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={props.label}
                    variant={props.variant ? props.variant : 'outlined'}
                    error={props.error}
                    value={props.value}
                    size={props.size}
                    name={props.name}
                    placeholder={props?.placeholder}
                    focused={props.focused ? props.focused : false}
                    onChange={(e) => {
                        if (e.target.value) {
                            handleSearchChange(e.target.value)
                        } else {
                            setOptionData([])
                            setSingleOption({ show: '', value: '' })
                        }
                    }}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <React.Fragment>
                                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </React.Fragment>
                        ),
                    }}
                    helperText={props.helperText}
                    inputRef={searchInputRef}
                />
            )}
            autoFocus={props.autoFocus}
        />
    )
}

export default SearchSelectComponent
